/* eslint @typescript-eslint/naming-convention: 0 */

import { buildWabunkaItemParamsByExperienceEvent, type ItemParams } from '@/wabunka-src/common/utils/googleAnalytics/common/wabunkaItem';
import { type Currency } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { WabunkaReservationFormStep1 } from '@/wabunka-src/features/Experience';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

export interface AddGuestInfoParams {
  value: number;
  currency: Currency;
  items: ItemParams[];
}
const buildAddGuestInfoParams = (experienceEvent: WabunkaExperienceEventViewModel, totalPriceIncludingTax: number): AddGuestInfoParams => {
  const item = buildWabunkaItemParamsByExperienceEvent(experienceEvent);
  return {
    value: totalPriceIncludingTax,
    currency: 'JPY',
    items: [item],
  };
};

/**
 * 発火タイミング：連絡先 4 種（氏名・メール・電話番号・国籍。代理予約なら参加者の氏名も）が全部埋まった瞬間に 1 回
 */
export const sendGAWabunkaAddGuestInfoEvent = (experienceEvent: WabunkaExperienceEventViewModel, form: WabunkaReservationFormStep1) => {
  sendWabunkaGAEvent('add_guest_info', buildAddGuestInfoParams(experienceEvent, form.totalPriceIncludingTax));
};
